import {
  getJobList,
  postJob,
  updateJob,
  deleteJob,
} from "@/services/job.service";

// initial state
const state = () => ({
  jobModel: {},
});

// mutations
const mutations = {
  setJobModel(state, data) {
    state.jobModel = data;
  },
};

// actions
const actions = {
  //Meslek Listesi
  async loadJobList() {
    return await getJobList().then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item, index) => {
        item.index = index + 1;
      });
      return items;
    });
  },

  async postJob(vuexContext, data) {
    return await postJob(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateJob(vuexContext, data) {
    return await updateJob(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteJob(vuexContext, data) {
    return await deleteJob(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addJobModel(vuexContext, data) {
    vuexContext.commit("setJobModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
